<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <settings-table></settings-table>
      </b-col><!--/.col-->
    </b-row><!--/.row-->
  </div>

</template>

<script>
  import SettingsTable from './SettingsTable.vue'

  export default {
    name: 'lottery-settings',
    components: {SettingsTable}
  }
</script>



// WEBPACK FOOTER //
// src/views/lottery/settings/Settings.vue